import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import { Spinner } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ChangeRequestModule, Modules } from "../../constants/Module";
import { Action } from "../../constants/Common";
import { toast } from "react-toastify";
import { withTranslation } from "react-i18next";

const ScopeModule = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const newTaskObject = {
    scope: props?.projectMeta?.scope?.new ?? "",
  };

  const taskValidation = Yup.object().shape({
    scope: Yup.string()
    .strict(true)
    .trim(props.t('Must not include leading and trailing spaces'))
    .max(2000, props.t("Too Long!")),
  });
  const formik = useFormik({
    initialValues: {
      ...newTaskObject,
    },
    validationSchema: taskValidation,
    validateOnMount: true,
    onSubmit: () => {
      setIsLoading(true);
      let hasChanges = false;
      if (formik.values.scope === props.project?.scope) {
        hasChanges = true;
      }

      if (!hasChanges) {
        const data = !formik.values.scope ? undefined : {
          scope: {
            old: `${props.project?.scope}`,
            new: formik.values.scope,
          }
        }
        props.validate(
          {
            module: ChangeRequestModule.PROJECT,
            event: Action.UPDATE,
            key: "scope",
          },
          data,
          () => {
            setIsLoading(false);
          },
          () => {
            setIsLoading(false);
          }
        );
      } else if (hasChanges) {
        setIsLoading(false);
        toast.error("Current scope and updated scope cannot be same!");
      }
    },
  });

  return (
    <div>
      <div className="changeRequest_schedule">
        <h6 className="mb-0">{props.t('Current Scope')}</h6>
        <p className="mb-0 mt-1">{props.t(props.project?.scope)}</p>
      </div>
      <div className="changeRequest_schedule mt-2">
        <h6 className="mb-0 mt-2">{props.t('Requested Scope')}</h6>
        <div className="row">
          <div className="col-md-12 changeRequest_datePicker mt-2">
            <TextField
              fullWidth
              multiline
              rows={3}
              id="outlined-multiline-static"
              label={props.t("Specify the change")}
              disabled={isLoading}
              name="scope"
              value={formik.values.scope}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              required
            />
            {formik.touched.scope && formik.errors.scope && (
              <span className="text-danger">{formik.errors.scope}</span>
            )}
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-end align-items-center mt-2">
        <button
          className={`edit_button ${
            isLoading ? "bg-secondary" : ""
          }`}
          disabled={isLoading}
          onClick={formik.handleSubmit}
        >
          {isLoading && (
            <Spinner className="ml-1 me-2" type="border" color="light" size="sm" />
          )}
          {props.t('Save Changes')}
        </button>
      </div>
    </div>
  );
};

export default withTranslation() (ScopeModule);
